import React from 'react';
import { Routes, Route, useParams } from 'react-router-dom';
import { ArchivedSummaryLayout } from './archived-summary-layout';

interface ArchivedSummaryProps {
  isApplicantSection?: boolean;
}

export const ArchivedSummary: React.FC<ArchivedSummaryProps> = (props) => {
  const params = useParams();

  return (
    <div>
      <Routes>
        <Route path="" element={<ArchivedSummaryLayout  archivedCaseId={params["caseId"] ?? ""} isApplicantSection={props.isApplicantSection} />} />
      </Routes>
    </div>
  );
};
